// extracted by mini-css-extract-plugin
export var cardHeader = "_ue-0";
export var reorderHandle = "_ue-3";
export var titleArea = "_ue-1";
export var titleAreaWithHandle = "_ue-2";